'use es6';

import styled from 'styled-components';
import { CANDY_APPLE, CANDY_APPLE_DARK } from 'HubStyleTokens/colors';
export default styled.div.withConfig({
  displayName: "DangerHandleButtonWrapper",
  componentId: "sc-1fn4vfq-0"
})([".hs-private.hs-private.hs-private & .uiButton.uiButton{background-color:", ";border:none;}.hs-private.hs-private.hs-private & .uiButton.uiButton:hover{background-color:", ";border:none;}"], CANDY_APPLE, CANDY_APPLE_DARK);